<script>
export default {
  props: {
    params: {
      type: Object,
      default: null,
    },
  },
  methods: {
    async handleClick() {
      const isConfirmed = await this.$swal
        .fire({
          icon: "question",
          title: "ยืนยันส่งออกข้อมูลในรูปแบบไฟล์ Excel",
          showCancelButton: true,
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          reverseButtons: true,
        })
        .then(({ value }) => !!value);

      if (!isConfirmed) return;

      this.$liff.openWindow({
        url:
          location.origin +
          this.$router.resolve({
            name: "export-point-history",
            query: {
              ...this.params,
            },
          }).href,
        external: true,
      });
    },
  },
  render() {
    return this.$scopedSlots.activator({
      on: {
        click: this.handleClick,
      },
    });
  },
};
</script>
